import { DxDiagnosisRequestAnswer } from '@src/api/types/dxDiagnosisAnswer';
import { DxDiagnosisQuestion } from '@src/api/types/dxDiagnosisQuestion';
import React, { MutableRefObject, useEffect } from 'react';

interface QuestionsProps {
  questions: DxDiagnosisQuestion[];
  userAnswers: DxDiagnosisRequestAnswer[];
  handleAnswerSelect: (questionId: number, choiceId: number) => void;
  showValidation: boolean;
  questionRefs: MutableRefObject<Record<number, HTMLDivElement | null>>;
}

const Questions: React.FC<QuestionsProps> = ({
  questions,
  userAnswers,
  handleAnswerSelect,
  showValidation,
  questionRefs,
}) => {
  useEffect(() => {
    const localRefs = { ...questionRefs.current };

    return () => {
      Object.keys(localRefs).forEach((key) => {
        localRefs[Number(key)] = null;
      });
    };
  }, [questionRefs]);
  return (
    <>
      {questions.length > 0 &&
        questions.map((question) => (
          <div
            id={`question-${question.id}`}
            key={question.id}
            ref={(el) => {
              questionRefs.current[question.id] = el;
            }}
            className='mx-auto w-full max-w-[900px] bg-white px-[100px] py-10 lg:px-12'
          >
            <div className='flex items-center gap-[10px]'>
              <div className='grid h-[30px] w-[74px] place-items-center bg-primary-500 font-medium text-white'>
                設問{question.question_no}
              </div>
              <p
                className={`text-sm text-warning-500 ${
                  showValidation &&
                  !userAnswers.some((answer) => answer.dx_diagnosis_question_id === question.id)
                    ? 'block'
                    : 'hidden'
                }`}
              >
                【設問{question.question_no}】の回答は必須です。
              </p>
            </div>
            <h2 className='mt-[20px] whitespace-normal break-words text-xl font-semibold leading-loose'>
              {question.question_text}
            </h2>
            <ul className='mt-[30px] flex flex-col gap-[10px]'>
              {question.dx_diagnosis_choices
                .sort((a, b) => b.score - a.score)
                .map((choice) => {
                  const currentAnswer = userAnswers.find(
                    (a) => a.dx_diagnosis_question_id === question.id,
                  );
                  return (
                    <li key={choice.id}>
                      <input
                        id={choice.id.toString()}
                        className='peer hidden'
                        type='radio'
                        value={choice.id.toString()}
                        name={`question${question.question_no}`}
                        checked={currentAnswer?.dx_diagnosis_choice_id === choice.id}
                        onChange={() => handleAnswerSelect(question.id, choice.id)}
                        data-testid={`question-${question.id}-choice-${choice.id}`}
                      />
                      <label
                        htmlFor={choice.id.toString()}
                        className='flex w-full cursor-pointer flex-col rounded-[5px] border border-gray-200 p-4 text-left transition-colors hover:border-primary-50 hover:bg-primary-50 peer-checked:border-primary peer-checked:bg-primary-50'
                      >
                        <h3 className='whitespace-normal break-words font-semibold'>
                          {choice.name}
                        </h3>
                        <p className='mt-[10px] whitespace-normal break-words'>
                          {choice.description}
                        </p>
                      </label>
                    </li>
                  );
                })}
            </ul>
          </div>
        ))}
    </>
  );
};

export default Questions;
